export default {
  getOrganisers: (state) => state.organisers,
  getLastFetch: (state) => state.lastFetch
}
